import script from "./Pagination.vue?vue&type=script&setup=true&lang=js"
export * from "./Pagination.vue?vue&type=script&setup=true&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=36740b3b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36740b3b"]])

export default __exports__